// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

export interface TokenSetLike {
	access_token: string;
	refresh_token: string;
	expires_at: number;
};

export class TokenSet {
	access_token: string;
	refresh_token: string;
	expires_at: number;

	constructor(input: TokenSetLike) {
		this.access_token = input.access_token;
		this.refresh_token = input.refresh_token;
		this.expires_at = input.expires_at;
	}

	expired() {
		return Date.now() > this.expires_at;
	}
}
